import { IconReorder, IconCalendarQuestion, IconCalendarOff } from '@tabler/icons-react';

// constant
const icons = {
  IconReorder,
  IconCalendarQuestion,
  IconCalendarOff
};
const request = {
  id: 'Requests',
  title: 'Request',
  type: 'group',
  children: [
    //  {
    //   id: 'vacationRequestsOverview',
    //   title: 'Vacation Requests Overview',
    //   type: 'item',
    //   url: '/vacation-requests-overview',
    //   icon: icons.IconCalendarQuestion,
    //   breadcrumbs: false
    //  },
    {
      id: 'vacationrequest',
      title: 'Vacation Requests',
      type: 'item',
      url: '/vacation-requests',
      icon: icons.IconCalendarQuestion,
      breadcrumbs: false
    },
    {
      id: 'absenceRequests',
      title: 'Absence Requests',
      type: 'item',
      url: '/unconfirmed',
      icon: icons.IconCalendarOff,
      breadcrumbs: false
    },
    {
      id: 'requests',
      title: 'Other Requests',
      type: 'item',
      url: '/requests',
      icon: icons.IconReorder,
      breadcrumbs: false
    },

  ]
};

export default request;
